export default __webpack_public_path__ + "static/media/cv151.03a9e3d2.png";